// This file is not yet translated.
/* eslint-disable i18next/no-literal-string */

import { Box, Checkbox, Icon, Typography, useTheme } from "@outschool/backpack";
import { SearchListingsQuery } from "@outschool/gql-frontend-generated";
import { fasBookmark, fasHeart } from "@outschool/icons";
import { savedClassesPath, savedSearchesPath } from "@outschool/routes";
import { TrackedButton } from "@outschool/ui-components-shared";
import { useSavedSearchesCount } from "@outschool/ui-components-website";
import { useLinkComponent } from "@outschool/ui-utils";
import React, { useRef } from "react";

import { pickSectionSearchFilters } from "../../../../shared/Section";
import { useSearchFilters } from "../../../lib/useSearchFilters";
import { MAX_NUMBER_OF_CLASSES_TO_COMPARE } from "../../classComparison/consts";
import { MobileListing } from "../../listings/MobileListing";
import { useSavedActivitiesCount } from "../../saving/graphql/hooks";
import { useMembershipRequirement } from "../../subscriptions/hooks/useMembershipRequirement";
import { ListingsProp } from "../common";

export function SavedActivitiesLinkMobile() {
  const Link = useLinkComponent();
  const savedActivitiesCount = useSavedActivitiesCount();
  return savedActivitiesCount ? (
    <TrackedButton
      variant="link"
      component={Link}
      to={savedClassesPath()}
      trackingName="activity_listings_link_saved_classes"
      sharedProperties={{ savedActivitiesCount }}
    >
      <Icon
        icon={fasHeart}
        sx={{
          marginRight: "0.5em",
          fontSize: "16px",
        }}
      />
      <Typography
        variant="inherit"
        sx={{
          fontWeight: "fontWeightMedium",
        }}
      >
        ({savedActivitiesCount})
      </Typography>
    </TrackedButton>
  ) : null;
}

export function SavedSearchesLinkMobile() {
  const Link = useLinkComponent();
  const savedSearchesCount = useSavedSearchesCount();
  return savedSearchesCount ? (
    <TrackedButton
      variant="link"
      component={Link}
      to={savedSearchesPath()}
      trackingName="activity_listings_link_saved_searches"
      sharedProperties={{ savedSearchesCount }}
    >
      <Icon
        icon={fasBookmark}
        sx={{
          marginRight: "0.5em",
          fontSize: "16px",
        }}
      />
      <Typography
        variant="inherit"
        sx={{
          fontWeight: "fontWeightMedium",
        }}
      >
        ({savedSearchesCount})
      </Typography>
    </TrackedButton>
  ) : null;
}

export function ListingsWrapperMobile({
  listings,
  // @ts-ignore TS(2339): Property 'startIndex' does not exist on type '{ st... Remove this comment to see the full error message
  tracking: { startIndex = 0, filters = {}, searchUid, group },
  firstNewResultIndex = 0,
  onFirstNewResultRef,
  isComparing,
  selectedListings,
  setSelectedListings,
}: ListingsProp) {
  const loadingMessageRef = useRef();
  const sectionSearchFilters = pickSectionSearchFilters(filters);

  const theme = useTheme();
  const { filters: searchFilters } = useSearchFilters();
  const { showCredits } = useMembershipRequirement();

  const hasPublicFundingFilter =
    (searchFilters?.fundingPrograms || []).length > 0;
  const onSelectToCompare = (
    listing: SearchListingsQuery["searchListings"]["listings"][0],
  ) => {
    if (selectedListings.includes(listing.activity.uid)) {
      setSelectedListings(
        selectedListings.filter(uid => uid !== listing.activity.uid),
      );
    } else if (selectedListings.length < MAX_NUMBER_OF_CLASSES_TO_COMPARE) {
      setSelectedListings([...selectedListings, listing.activity.uid]);
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "stretch",
        gap: "8px",
        [theme.breakpoints.up("sm")]: {
          gap: "8px",
        },
        padding: "0 1em",
        maxWidth: "100%",
        width: "100%",
        boxSizing: "border-box",
        overflow: "hidden",
        backgroundColor: theme.colors.peacock50,
      }}
    >
      {listings.map((listing, index) => {
        const isFirstNewResult =
          index === firstNewResultIndex && onFirstNewResultRef;
        return (
          <Box
            key={listing.activity.uid}
            ref={isFirstNewResult ? onFirstNewResultRef : undefined}
            sx={{
              width: "100%",
              maxWidth: "100%",
              boxSizing: "border-box",
              display: "flex",
              alignItems: "start",
            }}
            onClick={() => isComparing && onSelectToCompare(listing)}
          >
            {isComparing && (
              <Checkbox
                checked={selectedListings.includes(listing.activity.uid)}
                disabled={
                  selectedListings.length >= MAX_NUMBER_OF_CLASSES_TO_COMPARE &&
                  !selectedListings.includes(listing.activity.uid)
                }
              />
            )}

            <MobileListing
              activity={listing.activity}
              nextSection={listing.nextSection}
              leader={listing.leader}
              insertionId={listing.insertionId}
              // @ts-ignore TS(2322): Type 'SectionSearchFilters | null' is not assignab... Remove this comment to see the full error message
              sectionSearchFilters={sectionSearchFilters}
              trackingProperties={{
                searchUid,
                group,
                order: startIndex + index + 1,
              }}
              disabled={isComparing}
              listingIndex={startIndex + index}
              showCredits={showCredits}
              showFundingBadge={hasPublicFundingFilter}
              isSelected={selectedListings.includes(listing.activity.uid)}
            />
          </Box>
        );
      })}

      {/* @ts-ignore TS(2322): Type 'MutableRefObject<undefined>' is not assignab... Remove this comment to see the full error message */}
      <div key="lazy-listings-loading-more" ref={loadingMessageRef} />
    </Box>
  );
}
